import { useRootStore } from '@nandosaus/state-management';

const desktopNavPaddingNumber = 92;
const mobileNavPaddingNumber = 72;
const bannerHeight = 56;

export const useNavPadding = () => {
  const { PastOrdersStore } = useRootStore();
  const deliveryBannerActive = PastOrdersStore?.deliveryBannerActive || false;

  const mobileNavPadding = `${mobileNavPaddingNumber + (deliveryBannerActive ? bannerHeight : 0)}px`;
  const desktopNavPadding = `${desktopNavPaddingNumber + (deliveryBannerActive ? bannerHeight : 0)}px`;

  return {
    mobileNavPadding,
    desktopNavPadding,
  };
};
